class StampedIOClient {
  constructor(storeUrl, storeHash, publicKey) {
    this.storeUrl = storeUrl;
    this.storeHash = storeHash;
    this.publicKey = publicKey;
  }

  async searchForReview(searchTerm, productId, page = 1, take = 5) {
    const searchParams = new URLSearchParams({ take, page });
    const res = await fetch(
      `https://ce-admin-dashboard.fly.dev/api/reviews/find/${productId}/${searchTerm}?${searchParams.toString()}`
    );
    if (!res.ok) {
      throw new Error("Error fetching stamped.io product reviews by search:\n" + res.statusText);
    }
    return res.json();
  }

  async filterReviews(search) {
    const searchParams = new URLSearchParams({ search });
    const res = await fetch(
      `https://stamped.io/api/v2/${this.storeHash}/dashboard/reviews/?${searchParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    if (!res.ok) {
      throw new Error("Error fetching stamped.io product reviews by filter:\n" + res.statusText);
    }
    return res.json();
  }

  async productSummaries(productIds) {
    // productIds = [{ productId: 123 }]
    const res = await fetch("https://stamped.io/api/widget/badges", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        productIds,
        apiKey: this.publicKey,
        storeUrl: this.storeUrl,
      }),
    });
    if (!res.ok) {
      throw new Error("Error fetching stamped.io product summaries:\n" + res.statusText);
    }
    return res.json();
  }

  async productSummary(productId) {
    return this.productSummaries([{ productId }]);
  }

  async reviews(productId, page = 1, sortReviews = "featured", take = 5) {
    const searchParams = new URLSearchParams({
      productId,
      sortReviews,
      take,
      page,
      storeUrl: this.storeUrl,
      apiKey: this.publicKey,
    });
    const res = await fetch(`https://stamped.io/api/widget/reviews?${searchParams.toString()}`);
    if (!res.ok) {
      throw new Error("Error fetching stamped.io product reviews:\n" + res.statusText);
    }
    return res.json();
  }
}

export default new StampedIOClient("cozyearth.com", "293940", "2e32a49f-fc46-42fe-bc0a-6eec70692d4f");
